import { ActionTypes } from "../constants/action-types";
import { fromJS } from "immutable";
import { handleActions } from "redux-actions";

const initialState = fromJS({
  pending: true,
  tokenUsage: {},
  userLimit: {},
  subscriptionStatus: {},
  plans: [],
  paymentMethod: {},
  showSelectPlan: false,
  checkoutSession: null,
  showUpgradePlan: false,
  requiredEntitlement: null,
});

export const actions = {
  [ActionTypes.getBillingTokenUsage]: {
    next(state, { payload, error, pending }) {
      if (error) {
        return state.merge({ error, pending });
      }
      if (pending) {
        return state.merge({ pending });
      }
      if (payload == null || payload === undefined) {
        return state.merge({ pending, error });
      }
      const newState = {
        ...state.toJS(),
        pending: false,
        tokenUsage: payload,
      };
      return fromJS(newState);
    },
  },
  [ActionTypes.getBillingUserLimits]: {
    next(state, { payload, error, pending }) {
      if (error) {
        return state.merge({ error, pending });
      }
      if (pending) {
        return state.merge({ pending });
      }
      if (payload == null || payload === undefined) {
        return state.merge({ pending, error });
      }
      const newState = {
        ...state.toJS(),
        pending: false,
        userLimit: payload,
      };
      return fromJS(newState);
    },
  },
  [ActionTypes.getBillingSubscriptionStatus]: {
    next(state, { payload, error, pending }) {
      if (error) {
        return state.merge({ error, pending });
      }
      if (pending) {
        return state.merge({ pending });
      }
      if (payload == null || payload === undefined) {
        return state.merge({ pending, error });
      }
      const newState = {
        ...state.toJS(),
        pending: false,
        subscriptionStatus: payload,
      };
      return fromJS(newState);
    },
  },
  [ActionTypes.getBillingPlans]: {
    next(state, { payload, error, pending }) {
      if (error) {
        return state.merge({ error, pending });
      }
      if (pending) {
        return state.merge({ pending });
      }
      if (payload == null || payload === undefined) {
        return state.merge({ pending, error });
      }
      const newState = {
        ...state.toJS(),
        pending: false,
        plans: payload,
      };
      return fromJS(newState);
    },
  },
  [ActionTypes.getBillingPaymentMethod]: {
    next(state, { payload, error, pending }) {
      if (error) {
        return state.merge({ error, pending });
      }
      if (pending) {
        return state.merge({ pending });
      }
      if (payload == null || payload === undefined) {
        return state.merge({ pending, error });
      }
      const newState = {
        ...state.toJS(),
        pending: false,
        paymentMethod: payload,
      };
      return fromJS(newState);
    },
  },
  [ActionTypes.setCheckoutSession]: {
    next(state, { payload }) {
      if (payload === null) {
        return state;
      }
      const newState = {
        ...state.toJS(),
        checkoutSession: payload.data || null,
      };
      return fromJS(newState);
    },
  },
  [ActionTypes.showSelectPlanDialog]: {
    next(state) {
      const newState = {
        ...state.toJS(),
        showSelectPlan: true,
      };
      return fromJS(newState);
    },
  },
  [ActionTypes.hideSelectPlanDialog]: {
    next(state) {
      const newState = {
        ...state.toJS(),
        showSelectPlan: false,
        checkoutSession: null,
      };
      return fromJS(newState);
    },
  },
  [ActionTypes.showUpgradePlanDialog]: {
    next(state, { payload }) {
      const newState = {
        ...state.toJS(),
        showUpgradePlan: true,
        requiredEntitlement: payload.data || null,
      };
      return fromJS(newState);
    },
  },
  [ActionTypes.hideUpgradePlanDialog]: {
    next(state) {
      const newState = {
        ...state.toJS(),
        showUpgradePlan: false,
        requiredEntitlement: null,
      };
      return fromJS(newState);
    },
  },
};

export const billingReducer = handleActions(actions, initialState);
